// extracted by mini-css-extract-plugin
export default {"textarea":"AutoExpandingTextarea_textarea__0YDuV"};